import MobileNavigationItem from "components/molecules/MobileNavigationItem";
import {
  MOBILE_NAVIGATION_ENUMS,
  MOBILE_NAVIGATION_ITEM_TYPE,
} from "constants/navigation/mobileNavigation";
import "./styles.sass";
import { getEnv } from "../../../utils/hostname";

type MobileMenuProps = {
  list: MOBILE_NAVIGATION_ITEM_TYPE[];
  notifications?: MOBILE_NAVIGATION_ENUMS[];
};

const MobileMenu = (props: MobileMenuProps) => {
  const { list, notifications } = props;
  const isStage =
    getEnv() === "stage" || getEnv() === "dev" || getEnv() === "local";
  return (
    <div className="MobileMenu">
      {list.map((item: MOBILE_NAVIGATION_ITEM_TYPE) => {
        if (item.id === MOBILE_NAVIGATION_ENUMS.SPORT && !isStage) {
          return null;
        }
        return (
          <MobileNavigationItem
            key={item.id}
            id={item.id}
            name={item.name}
            url={item.url}
            icon={item.icon}
            hasNotify={notifications?.includes(item.id)}
          />
        );
      })}
    </div>
  );
};

export default MobileMenu;
